// src/services/lab/salleService.js
import api from '../api';

const BASE = 'salles/';

export const getSalles = async (params = {}) => {
  const res = await api.get(BASE, { params });
  return res.data;
};

export const getSalle = async (id) => {
  const res = await api.get(`${BASE}${id}/`);
  return res.data;
};

export const createSalle = async (data) => {
  const res = await api.post(BASE, data);
  return res.data;
};

export const updateSalle = async (id, data) => {
  const res = await api.patch(`${BASE}${id}/`, data);
  return res.data;
};

export const deleteSalle = async (id) => {
  const res = await api.delete(`${BASE}${id}/`);
  return res.data;
};

/** Agenda d'une salle : les sessions qui l'occupent. */
export const getPlanningSalle = async (id) => {
  const res = await api.get(`${BASE}${id}/planning/`);
  return res.data;
};

/**
 * Salles libres sur un créneau.
 * Le Lab ne savait pas répondre à cette question : il stockait un statut
 * « Occupée » figé au lieu de croiser les réservations.
 */
export const getSallesDisponibles = async (debut, fin, capaciteMin) => {
  const res = await api.get(`${BASE}disponibles/`, {
    params: { debut, fin, ...(capaciteMin ? { capacite_min: capaciteMin } : {}) },
  });
  return res.data;
};

// ── Équipements ──
export const getEquipements = async (params = {}) => {
  const res = await api.get(`${BASE}equipements/`, { params });
  return res.data;
};

export const createEquipement = async (data) => {
  const res = await api.post(`${BASE}equipements/`, data);
  return res.data;
};

export const updateEquipement = async (id, data) => {
  const res = await api.patch(`${BASE}equipements/${id}/`, data);
  return res.data;
};

export const deleteEquipement = async (id) => {
  const res = await api.delete(`${BASE}equipements/${id}/`);
  return res.data;
};

export const TYPES_SALLE = [
  { value: 'amphitheatre',  label: 'Amphithéâtre' },
  { value: 'classe',        label: 'Classe' },
  { value: 'lab',           label: 'Laboratoire' },
  { value: 'salle_reunion', label: 'Salle de réunion' },
];

// « Occupée » n'est pas un statut : l'occupation se déduit des sessions.
export const STATUTS_SALLE = [
  { value: 'disponible',  label: 'Disponible' },
  { value: 'maintenance', label: 'En maintenance' },
  { value: 'fermee',      label: 'Fermée' },
];

/**
 * Salles libres pour TOUTES les séances données ({date, heure_debut, heure_fin}).
 * `sessionId` : la session en cours d'édition, qui ne se bloque pas elle-même.
 * Aide à la saisie : le conflit est de toute façon refusé à l'enregistrement.
 */
export const getSallesLibresPourSeances = async (seances, sessionId = null) => {
  const res = await api.post('sessions/salles-libres/', { seances, session: sessionId });
  return res.data;
};
